import moment from "moment";
import {
  getKeyByValueOfJson,
  getValueByKeyOfJson,
} from "../../Configs/Validator/FormValidations";
import educationData from "../JSON/educationData.json";
import fundPerformJson from "../JSON/fundPerformDummy.json";
// import fundDetailJson from '../JSON/fundDetailDummy.json'
import maritalStatusData from "../JSON/maritalStatusData.json";
import occupationData from "../JSON/occupationData.json";
import organizationTypeData from "../JSON/organizationTypeData.json";
import stateData from "../JSON/stateData.json";
import { toJS } from "mobx";
import {
  numDifferentiation,
  getSHA256Hash,
  callMiddlewareAPI,
} from "../../Components/Common/CommonFunctions";
import { ApiName } from "@ipru-common/services/ApiEndpoints.js";
const IP_URL = process.env.REACT_APP_IP_URL;
// const LEAD_URL = process.env.REACT_APP_LEAD_URL

// const TRACER_URL = process.env.REACT_APP_TRACER_URL
// const GROUP_EMP_URL = process.env.REACT_APP_GROUP_EMP_URL
// const FUND_API_BASE_URL = "https://buyuat.iprulifeinsurance.com/uatdigi/funds-by-product.htm?productCode=UW3"
// const FUND_API_BASE_URL = window.location.href.includes("testing") ? process.env.REACT_APP_FUND_PREPROD_API_BASE_URL : process.env.REACT_APP_FUND_API_BASE_URL
// const FUND_DETAIL_BASE_URL = process.env.REACT_APP_FUND_DETAIL_BASE_URL
// const FUND_DETAIL_BASE_URL = window.location.hostname === "www.icicilife.com" ? process.env.REACT_APP_CUSTOM_IPRU_FUND_DETAIL_BASE_URL : process.env.REACT_APP_CUSTOM_DEP_FUND_DETAIL_BASE_URL

var checkloaded = false;
var RestoreDatLayer_Interval_Count = 0;

const FundAPI = async () => {
  var startDate = moment().subtract(7, "days").format("DD-MMM-YY");
  var endDate = moment().format("DD-MMM-YY");
  // var FUND_URL = FUND_API_BASE_URL + "&startDate=" + startDate + "&endDate=" + endDate
  const data = { productCode: "UW3", startDate: startDate, endDate: endDate };
  // var dynamicversion = new Date().getTime()
  // var FUND_URL = FUND_API_BASE_URL + "?v=" + dynamicversion

  // const reqParams = {
  //   method: "GET",
  //   mode: 'cors'
  // }

  // const response = await fetch(FUND_URL, reqParams)
  const response = await callMiddlewareAPI(ApiName.FUND_PERFORMANCE, data)
    .then(async (result) => {
      // var updatedFund = await FundDetailAPI(result, startDate, endDate)
      // console.info("Fund Return :", result)
      // return updatedFund
      return result;
    })
    .catch(async () => {
      // var updatedFund = await FundDetailAPI(fundPerformJson, startDate, endDate)
      // console.info("Fund Error Return :", updatedFund)
      return fundPerformJson;
    });

  // console.info("Start Date :", startDate)
  // console.info("End Date :", endDate)

  return response;
};

// https://buy.icicilife.com/buy/funds-product-performance.htm?fundCode=F50F&startDate=20-MAR-19&endDate=26-NOV-21

const FundDetailAPI = async (resultArray, startDate, endDate) => {
  var finalArray = [];
  // const reqParams = {
  //   method: "GET",
  // }

  for (var i = 0; i < resultArray.length; i++) {
    // var FUND_DETAIL_URL = FUND_DETAIL_BASE_URL + "?fundCode=" + resultArray[i]["LAfundCode"] + "&startDate=" + startDate + "&endDate=" + endDate
    // var dynamicversion = new Date().getTime()
    // var FUND_DETAIL_URL = FUND_DETAIL_BASE_URL + resultArray[i]["LAfundCode"] + ".json?v=" + dynamicversion
    const data = { fundCode: resultArray[i]["LAfundCode"], startDate, endDate };
    const response = await callMiddlewareAPI(
      ApiName.FUND_PRODUCT_PERFORMANCE,
      data,
    )
      .then(async (result) => {
        var inseptionDate = resultArray[i]["InceptionDate"];
        var inceptionDateValue = moment(inseptionDate).format("DD-MM-YYYY");
        var fundNav = result["fundNavGraph"];
        var rawValue = result["fundSummary"][0]["assetsInvested"];
        var value = numDifferentiation(rawValue, 2);
        resultArray[i]["AssetsInvested"] = value;
        var rawFundDate = resultArray[i]["crteDate"];
        var FundDate = moment(rawFundDate)
          .subtract(1, "months")
          .endOf("month")
          .format("DD-MM-YYYY");
        var NAVLatestDateValue = resultArray[i]["NAVLatestDate"];
        var NAVLatestDate = moment(NAVLatestDateValue).format("DD-MM-YYYY");
        resultArray[i]["NAVLatestDate"] = NAVLatestDate;
        resultArray[i]["FundDate"] = FundDate;
        //resultArray[i]["FundDate"] = fundNav[Object.entries(fundNav).length - 1]["x"]
        resultArray[i]["InceptionDate"] = inceptionDateValue;
        finalArray.push(resultArray[i]);
        console.info("Fund Detail Return :", result["fundSummary"]);
        return finalArray;
      })
      .catch((error) => {
        // var fundNav = fundDetailJson["fundNavGraph"]
        // var inseptionDate = resultArray[i]["InceptionDate"]
        //var inceptionDateValue = moment(inseptionDate).format("DD-MMM-YYYY")
        // resultArray[i]["FundDate"] = fundNav[Object.entries(fundNav).length - 1]["x"]
        var NAVLatestDateValue = resultArray[i]["NAVLatestDate"];
        var NAVLatestDate = moment(NAVLatestDateValue).format("DD-MM-YYYY");
        var rawFundDate = resultArray[i]["crteDate"];
        var FundDate = moment(rawFundDate)
          .subtract(1, "months")
          .endOf("month")
          .format("DD-MM-YYYY");
        //  resultArray[i]["FundDate"] = "-"
        //resultArray[i]["InceptionDate"] = inceptionDateValue
        resultArray[i]["InceptionDate"] = "-";
        resultArray[i]["NAVLatestDate"] = NAVLatestDate;
        resultArray[i]["FundDate"] = FundDate;
        resultArray[i]["AssetsInvested"] = "-";
        finalArray.push(resultArray[i]);
        // console.info("Fund Detail Error Return :", resultArray[i])
        return finalArray;
      });
  }

  return finalArray;
};

const ipAPI = async () => {
  const reqParams = {
    method: "GET",
  };

  const response = await fetch(IP_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      // console.info("IP Return :", result)
      return result;
    })
    .catch((error) => {
      // console.info("Error :", error)
      return error;
    });

  // console.info("IP Response :", response)
  return response;
};

const leadWSAPI = async (formStore, Suit_LMS12) => {
  var MAIN_URL = window.location.href;
  var URL_OBJ = new URL(MAIN_URL);
  var uidCode = URL_OBJ.searchParams.get("UID");
  // let JwtToken = await window.UserSession["JwtToken"]

  var glbUid =
    uidCode === null || uidCode === undefined || uidCode === "" ? 480 : uidCode;
  window.Glb_UID = glbUid;

  // var PROD_CODE = window.UserInput["productId"] //FormStore.quote_formTab === "0" ? "I13" : "I14"
  var LMS_column_12 = "YES";
  if (typeof Suit_LMS12 === "boolean") {
    LMS_column_12 = Suit_LMS12 ? "YES" : "NO";
  } else {
    LMS_column_12 = formStore.calc_checkOne ? "YES" : "NO";
  }

  var pageURL = new URL(window.location.href);
  var temp_obj = {
    utm_campaign:
      pageURL.searchParams.get("utm_campaign") != null
        ? pageURL.searchParams.get("utm_campaign")
        : "",
    utm_keyword:
      pageURL.searchParams.get("utm_term") != null
        ? pageURL.searchParams.get("utm_term")
        : "",
    utm_adcontent:
      pageURL.searchParams.get("utm_content") != null
        ? pageURL.searchParams.get("utm_content")
        : "",
    utm_source:
      pageURL.searchParams.get("utm_source") != null
        ? pageURL.searchParams.get("utm_source")
        : "",
    // "utm_campaign": ipru_getParameterByName("utm_campaign"),
    // "utm_keyword": ipru_getParameterByName("utm_term"),
    // "utm_adcontent": ipru_getParameterByName("utm_content"),
    // "utm_source": ipru_getParameterByName("utm_source"),
  };
  temp_obj = JSON.stringify(temp_obj);

  const bodyLeadWS = {
    LMS_uid: glbUid,
    LMS_product_code: "KV",
    LMS_gender: formStore.calc_gender,
    LMS_dob: formStore.calc_dob,
    LMS_mobile: formStore.calc_phone,
    LMS_email: formStore.calc_email,
    //LMS_product_specific: "google_search_q-,call-Yes,vCommId-",
    keyword: "",
    LMS_TRAI_FLAG: formStore.calc_checkOne ? "YES" : "NO",
    matchtype: "",
    LMS_firstName: "",
    LMS_lastName: "",
    LMS_tobacco: "",
    LMS_sumassured: 600000,
    LMS_policyTerm: 20,
    LMS_policypaymentfrequency: "monthly",
    LMS_staff: "No",
    Lumpsum: "0",
    Monthly_income: "0",
    Term_critical_illness: "Self",
    LMS_pageName: "ULIP : Save N Grow Calculator",
    LMS_pageURL: window.location.href.split("?")[0],
    LMS_session_id: "",
    LMS_typeofplan: "LumpSum",
    LMS_column_1: "1",
    LMS_column_2: "",
    LMS_column_3: formStore.calc_annual,
    LMS_column_4: "",
    LMS_column_5: "",
    LMS_column_6: formStore.calc_buyingFor,
    LMS_column_7: glbUid + "",
    LMS_column_8: "",
    LMS_column_9: "",
    LMS_column_10: "",
    LMS_column_11: formStore.calc_checkTwo ? "YES" : "NO",
    LMS_column_12: LMS_column_12,

    LMS_premium: 5000,
    LMS_premiumterm: 10,
    LmsAdditionalDetails: JSON.stringify(temp_obj),
  };

  // const bodyLeadWSObj = new URLSearchParams()
  // for (var i in bodyLeadWS) {
  //   bodyLeadWSObj.append(i, bodyLeadWS[i])
  // }

  // const reqParams = {
  //   method: "POST",
  //   body: JSON.stringify(bodyLeadWS),
  //   credentials: "include",
  //   mode: "cors",
  //   headers: {
  //     // "x-api-key": process.env.REACT_APP_LEAD_URL_X_API_KEY,
  //     // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${JwtToken}`
  //   }
  // }
  const response = await callMiddlewareAPI(ApiName.LEADWS, bodyLeadWS)
    .then((result) => {
      console.info("Lead Return :", result);
      return result;
    })
    .catch((error) => {
      console.info("Lead Error :", error);
      return error;
    });

  window.fireConversion();
  // const response = await fetch(LEAD_URL, reqParams)
  //   .then((res) => res.json())
  //   .then((result) => {
  //     // console.info("Lead Return :", result)
  //     window.fireConversion()
  //     return result
  //   })
  //   .catch((error) => {
  //     // console.info("Lead Error :", error)
  //     window.fireConversion()
  //     return error
  //   })

  // console.info("Lead Body :", body)
  // console.info("Lead Response :", response)
  return response;
};

const groupEmployeeAPI = async (body) => {
  // console.info("Group Employee Request :", body)
  const reqParams = {
    headers: {
      Accept: "application/json, text/javascript",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
    method: "POST",
    credentials: "include",
    mode: "cors",
  };

  const response = await callMiddlewareAPI(ApiName.EMP_DETAIL, body)
    .then((result) => {
      // console.info("Group Employee Return :", result)
      return result;
    })
    .catch((error) => {
      // console.info("Group Employee Error :", error)
      return error;
    });

  // console.info("Group Employee Request :", body)
  // console.info("Group Employee Response :", response)
  return response;
};

const DataLayerFn = async (
  event,
  FormStore,
  question,
  button,
  options,
  extraFlag,
) => {
  var UserAge = Math.sign(FormStore.calc_age) === -1 ? "" : FormStore.calc_age;
  var validDate =
    UserAge === ""
      ? ""
      : moment(FormStore.calc_dob, "DD/MM/YYYY").format("MM/YY");
  validDate = validDate === "Invalid date" ? "" : validDate;

  var quoteSeen = extraFlag["QuoteFlag"] || FormStore.quote_modal;
  quoteSeen =
    quoteSeen === undefined ? FormStore.quote_modalLoader : !quoteSeen;
  var SuitabilityCalculation = extraFlag["SuitabilityCalculation"] ?? "";
  var PolicyTerm = FormStore.quote_policyTerm;
  var PolicyType = FormStore.quote_paymentFreq;
  var PaymentFrequency = FormStore.quote_every;

  var payFor = FormStore.quote_payFor; // Quote Page

  var AnnualIncome = FormStore.calc_annual;

  var eventName = event.split("||")[0];
  var sectionName = event.split("||")[1];
  // console.info("DATALAYER FLAG :", PolicyTerm)
  var FundMainArray = await toJS(FormStore.quote_investFundSelected);
  var FundsDataArray = FundMainArray.map(
    (x) => x.AltName + "," + x.fundAllocation,
  );
  var FundsData = FundsDataArray.join(" | ");
  FundsData = FundsDataArray.length > 0 ? " | " + FundsData : "";
  var SW =
    FormStore.quote_cardOneRadio === "N"
      ? "SystematicWithdrawal_Later"
      : "SystematicWithdrawal_Now";
  var ATS =
    FormStore.quote_cardTwoRadio === "N"
      ? " | automaticTransferStrategy_No"
      : " | automaticTransferStrategy_Yes";

  try {
    if (document.querySelectorAll(".QuoteFunds_Card.NotAvailable").length > 0) {
      ATS = "";
    }
    if (FormStore.quote_fundsTab !== 0) {
      ATS = "";
    }
  } catch {}

  var userVisitedFunds = window.userVisitedFunds;
  var isAppFormLoaded = window.isAppFormLoaded;
  const education =
    (await levelHandler("appform-details", "education")) !== ""
      ? await getValueByKeyOfJson(
          educationData,
          window.UserDataJSON["appform-details"]["education"],
        )
      : "";
  const maritalStatus =
    (await levelHandler("appform-details", "mrtlSts")) !== ""
      ? await getValueByKeyOfJson(
          maritalStatusData,
          window.UserDataJSON["appform-details"]["mrtlSts"],
        )
      : "";
  const occupation =
    (await levelHandler("appform-details", "occ")) !== ""
      ? await getValueByKeyOfJson(
          occupationData,
          window.UserDataJSON["appform-details"]["occ"],
        )
      : "";
  const organizationType =
    (await levelHandler("appform-details", "orgType")) !== ""
      ? await getValueByKeyOfJson(
          organizationTypeData,
          window.UserDataJSON["appform-details"]["orgType"],
        )
      : "";
  const state =
    (await levelHandler("Communication", "state")) !== ""
      ? await getKeyByValueOfJson(
          stateData,
          window.UserDataJSON["Communication"]["state"],
        )
      : "";

  var ApplicationNumber = await levelHandler("appNO", "");
  var OrganizationName = await levelHandler("appform-details", "orgNameDesc");
  var City = await levelHandler("Communication", "city");
  var NomineeRelationship = await levelHandler("Nominee", "relationship");
  var NomineeDOB = await levelHandler("Nominee", "nomineeDob");
  var ExistingCustomer = await levelHandler("ExistingCustomer", "");
  var GoalHorizon = await levelHandler("suitabilityMatrix", "goalHorizon");
  var InsurancePortfolioHeld = await levelHandler(
    "suitabilityMatrix",
    "insurancePortfolioHeld",
  );
  var RiskProfile = await levelHandler("suitabilityMatrix", "riskProfile");
  var phone = await getSHA256Hash(toJS(FormStore.calc_phone));
  var email = await getSHA256Hash(toJS(FormStore.calc_email));
  var MAIN_URL = window.location.href;
  var URL_OBJ = new URL(MAIN_URL);
  var uidCode = URL_OBJ.searchParams.get("UID");

  var glbUid =
    uidCode === null || uidCode === undefined || uidCode === "" ? 480 : uidCode;

  var tempLayer = {
    event: eventName,
    ProductCode: "KV",
    ProductName: "ICICI Pru Save N Grow",
    pageName: "ULIP : Save N Grow Calculator",
    pageType: "top-ulips : icici-pru-savengrow-ulip",
    subsection1: "ulip-insurance-plans",
    subsection2: "icici-pru-savengrow-ulip",
    channel: "savings",
    Subchannel: "ulip-insurance-plans-wealth",
    SectionName: sectionName,
    UID: window.Glb_UID,
    Gender: FormStore.calc_gender,
    Tobacco: "",
    DOB: validDate,
    Age: UserAge,
    Premium: quoteSeen ? "" : FormStore.quote_invest,
    MonthlyPremium: "",
    YearlyPremium: "",
    nyPremium: "",
    LifeCoverSelected: quoteSeen ? "" : window.UserInput["lifeCover"],
    PaymentFrequency: quoteSeen ? "" : PaymentFrequency,
    PolicyTerm: quoteSeen ? "" : PolicyTerm,
    CoveredAge: quoteSeen
      ? ""
      : Number(payFor) + 1 + Number(FormStore.calc_age) + Number(PolicyTerm),
    PaymentTerm: quoteSeen
      ? ""
      : PolicyType === "Regular"
        ? PolicyTerm
        : payFor,
    NetworkUID1: quoteSeen
      ? ""
      : FormStore.calc_phone === ""
        ? ""
        : (phone ?? ""), // Mobile No Encrypted in SHA256
    NetworkUID2: quoteSeen
      ? ""
      : FormStore.calc_email === ""
        ? ""
        : (email ?? ""), // Email id Encrypted in SHA256
    ADBRValue: "",
    CIValue: "",
    OptionSelected: options,
    AnnualIncome: AnnualIncome,
    PolicyType: quoteSeen ? "" : PolicyType + " Pay",
    PayoutOptionSelected: quoteSeen ? "" : "LumpSum",
    ApplicationNumber: quoteSeen ? "" : ApplicationNumber,
    MaritalStatus: !isAppFormLoaded ? "" : maritalStatus,
    Education: quoteSeen ? "" : education,
    Occupation: quoteSeen ? "" : occupation,
    OrganizationName: quoteSeen ? "" : OrganizationName,
    OrganizationType: quoteSeen ? "" : organizationType,
    City: quoteSeen ? "" : City,
    State: quoteSeen ? "" : state,
    NomineeRelationship: quoteSeen ? "" : NomineeRelationship,
    NomineeDOB: quoteSeen
      ? ""
      : NomineeDOB !== ""
        ? moment(NomineeDOB, "DD/MM/YYYY").format("MM/YY")
        : "",
    Button: button,
    EstimatedReturnAt4: quoteSeen
      ? ""
      : FormStore.quote_arr === 8
        ? ""
        : FormStore.api_4percentage === 0
          ? ""
          : FormStore.api_4percentage, // Reverse Condtions
    EstimatedReturnAt8: quoteSeen
      ? ""
      : FormStore.quote_arr === 4
        ? ""
        : FormStore.api_8percentage === 0
          ? ""
          : FormStore.api_8percentage, // Reverse Condtions
    InvestStyle: quoteSeen
      ? ""
      : !userVisitedFunds
        ? `${FormStore.quote_investStrat}`
        : `${FormStore.quote_investStrat}${FundsData} | ${window.UserInput.invest_type} | ${SW}${ATS}`,
    NPSSubscriber: "",
    AnnuityFrequency: "",
    AnnuityAmount: "",
    CancerCover: "",
    HeartCover: "",
    ExistingCustomer: quoteSeen ? "" : ExistingCustomer,
    HospitalCashBenefit: "",
    IncreasingCoverBenefit: "",
    IncomeBenefit: "",
    PolicyHolder: FormStore.calc_buyingFor,
    GuaranteedReturn: "",
    SuitabilityCalculation: SuitabilityCalculation,
    GoalHorizon: quoteSeen ? "" : GoalHorizon,
    InsurancePortfolioHeld: quoteSeen ? "" : InsurancePortfolioHeld,
    RiskProfile: quoteSeen ? "" : RiskProfile,
    OtherInsurancePolicy: "",
    UserResponse: "",
    retirement: "",
    Savings: "",
    HomeLoan: "",
    OtherLoan: "",
    CarBrand: "",
    CarModel: "",
    CarVarient: "",
    TypeOfOwnership: "",
    GroupEmployee: "",
    Question: question,
    jointlifeDOB: "",
    jointlifeRelationship: "",
    Device: window.innerWidth > 768 ? "Desktop" : "Mobile", // Desktop / Mobile
    UID_User: glbUid,
  };

  console.info("DataLayer", tempLayer);
  checkloaded = window.dataLayer.find((item) => item.event === "gtm.load");
  if (!checkloaded) {
    window.tempDataLayer_BeforeCheckLoaded.push(tempLayer);
  } else {
    window.dataLayer.push(tempLayer);
  }
  return "";
};

const tracerAPI = async (FormStore, type) => {
  var MAIN_URL = window.location.href;
  var URL_OBJ = new URL(MAIN_URL);
  var uidCode = URL_OBJ.searchParams.get("UID");

  var glbUid =
    uidCode === null || uidCode === undefined || uidCode === "" ? 480 : uidCode;
  window.Glb_UID = glbUid;

  var dobVal = FormStore.calc_dob;
  var IP_ADD = window.ipAddress;
  var associationId = dobVal.split("/")[2] + FormStore.calc_phone.slice(3);
  associationId = type === 1 ? associationId : associationId + "" + IP_ADD;

  var ModalPremium = FormStore.quote_invest;
  ModalPremium = ModalPremium === "" ? "0" : ModalPremium;
  var AnnuityAmount = FormStore.quote_annuityAmount;
  AnnuityAmount = AnnuityAmount === "" ? "0" : AnnuityAmount;

  var PROD_CODE = window.UserInput["productId"]; //FormStore.quote_formTab === "0" ? "I13" : "I14"

  const bodyTracerA = {
    message: "comition",
    properties: {
      amount: "0",
      gender: FormStore.calc_gender,
      cardType: "ICICI BANK",
      mobileNo: FormStore.calc_phone,
      emailID: FormStore.calc_email,
      productCode: PROD_CODE,
      vendorUid: glbUid,
      associationId: associationId, // "19999999999", // "19999999999142.142.142.142"
      premium: ModalPremium,
      message: window.location.hostname + window.location.pathname,
      deviceId: "19 Jun 1989",
      ipAddress: IP_ADD,
    },
    source: process.env.REACT_APP_BODY_TRACER_A_SOURCE,
  };

  const reqParams = {
    method: "POST",
    body: JSON.stringify(bodyTracerA),
    credentials: "include",
    mode: "cors",
    headers: { "Content-Type": "application/json" },
  };

  const response = await callMiddlewareAPI(ApiName.TRACER, bodyTracerA)
    .then((result) => {
      // console.info("Tracer A Return :", result)
      return result;
    })
    .catch((error) => {
      // console.info("Tracer A Error :", error)
      return error;
    });

  // console.info("Tracer A Response :", response)
  return response;
};

var RestoreDatLayer_Interval = setInterval(() => {
  checkloaded = window.dataLayer.find((item) => item.event === "gtm.load");
  console.log("setinterval", checkloaded, RestoreDatLayer_Interval_Count);
  if (RestoreDatLayer_Interval_Count > 50 || checkloaded) {
    console.log("setinterval2", checkloaded, RestoreDatLayer_Interval_Count);
    window.dataLayer.push(...window.tempDataLayer_BeforeCheckLoaded);
    window.tempDataLayer_BeforeCheckLoaded = [];
    clearInterval(RestoreDatLayer_Interval);
  }
  RestoreDatLayer_Interval_Count++;
}, 500);

const crashHandler = async (value, altVal) => {
  try {
    return value === undefined ? altVal : value;
  } catch {
    return altVal;
  }
};

const levelHandler = async (lvl1, lvl2) => {
  try {
    if (lvl2 === "") return window.UserDataJSON[lvl1];
    else return window.UserDataJSON[lvl1][lvl2];
  } catch {
    return "";
  }
};

export { ipAPI, leadWSAPI, tracerAPI, groupEmployeeAPI, DataLayerFn, FundAPI };
